var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRawGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0,
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0,0)",
    style: {}
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M344.578 493.54l-117.214-2.024L118.9 338.536l14.355-51.353 35.264 9.38 40.145 42.033-17.467-59.874 23.836-35.358-42.748-104.034 43.165-79.45 72.434 22.468 46.26 80.46-29.474 5-38.478-35.017 22.568 48.064-.672 37.364-26.09 18.224 34.95 1.284 47.145 23.835 28.75-27.874 38.488 19.057 10.647 37.578-18.97-13.784-78.166 39.967-44.983-15.39 5.86-27.153-42.766 3.274 23.573 11.913-9.49 22.943 58.037 31.285 20.34 79.423-15.45 34.73 29.397-20.36 66.83-9.438-71.61 65.81zm-158.524-3.538l-53.48-2.296 27.663-64.006 34.38 49.695-8.563 16.607zm-86.78-37.04l-11.08-34.875-35.503-10.204 34.858-11.09 10.212-35.5 11.09 34.855 35.502 10.22-34.857 11.082-10.22 35.51zm252.983-33.208l-21.565-84.228 72.042-38.99 53.683 59.322-18.665 52.23-85.495 11.666zM169.47 280.677l-59.133-15.612-20.298-69.16 66.064-37.45 36.94 84.126-23.573 38.097zm172.106-38.972l-38.385-19.66 1.574-38.86 43.607-9.917 26.753 39.296-33.547 29.14zm58.845-47.23l-14.234-45.425-46.14-13.46 45.41-14.262 13.46-46.132 14.252 45.41 46.14 13.478-45.41 14.235-13.477 46.156zM327.01 124.9l-28.666-56.762-28.972-7.96 22.645-41.718 29.312 14.278 17.84 59.542-12.16 32.62z",
    fill: "#a36528",
    fillOpacity: 1,
    clipPath: "url(#icon-bg)",
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRawGood);
export default __webpack_public_path__ + "static/media/raw-good.a0aafcbc8d24fbfdb6109865b12bc1c2.svg";
export { ForwardRef as ReactComponent };